import { FormControlLabel, Checkbox } from '@material-ui/core'
import { FC } from 'react'
import { WrappedFieldProps } from 'redux-form'

import styles from './styles.module.css'
interface FieldProps {
  className: string
  label: string
  inputStyles?: 'string'
  custom: any
}
const ReduxCheckbox: FC<WrappedFieldProps & FieldProps> = ({
  input,
  label,
  className,
  inputStyles,
  custom
}) => {
  return (
    <div className={styles.container}>
      {!custom ? (
        <>
          {' '}
          <FormControlLabel
            control={
              <Checkbox
                checked={input.value ? true : false}
                onChange={input.onChange}
                style={{ color: '#4f9b44' }}
                className={inputStyles}
              />
            }
            label={label}
          />
        </>
      ) : (
        <label className={`${styles.control} ${styles.controlCheckbox}`}>
          <input
            onChange={input.onChange}
            checked={input.value ? true : false}
            type='checkbox'
          />
          <div className={styles.controlIndicator}>
            {' '}
            <span className={styles.checkboxLabel}>{label}</span>
          </div>
        </label>
      )}
    </div>
  )
}

export default ReduxCheckbox
